import { useTheme } from '@mui/material';

/**
 * Farbschema der Google-Karten passend zum Nachtmodus.
 *
 * Google übernimmt `colorScheme` nur beim Erzeugen der Karte. Deshalb liefert
 * der Hook auch einen `key`: Als React-Key an <GoogleMap> gesetzt, baut sich
 * die Karte beim Umschalten neu auf. Alles, was an der Karte hängt (Marker,
 * Polygone, Effekte mit `[map]`), folgt der neuen Instanz.
 */
const useMapColorScheme = () => {
  const dark = useTheme().palette.mode === 'dark';
  const colorScheme = dark ? 'DARK' : 'LIGHT';
  return { colorScheme, key: `map-${colorScheme}` };
};

export default useMapColorScheme;
